import React from "react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-1.5 text-xs text-gray-400">
          <div className="flex items-center gap-1.5">
            <span className="font-medium text-gray-600">Sadguru Seva Sangh Trust</span>
            <span className="hidden sm:inline text-gray-300">·</span>
            <span>Daily Wage Register</span>
          </div>
          <div className="flex items-center gap-2.5">
            <span>© {currentYear} All rights reserved</span>
            <span className="h-3 w-px bg-gray-200 hidden sm:block" />
            <span className="font-mono text-[10px] text-gray-300">v1.0.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;